import {
  FETCH_CONTENTSTACK_ASYNC_SUCCESS,
  CONTENTSTACK_ASYNC_ERROR,
  FETCH_CONTENTSTACK_ASYNC_ACTION_START
} from 'actions/contentstack';

const initialState = {
  isLoading: false,
  isError: false,
  errorMessage: null,
  heroBanner: {},
  cardContainer: {},
  featureCallout: {}
};

const actionsMap = {
  [FETCH_CONTENTSTACK_ASYNC_ACTION_START]: (state) => {
    return {
      ...state,
      isLoading: true,
      errorMessage: null,
    };
  },
  [FETCH_CONTENTSTACK_ASYNC_SUCCESS]: (state, action) => {
    return {
      ...state,
      heroBanner: action.payload.heroBanner.hero_banner,
      cardContainer: action.payload.cardContainer.card_container,
      featureCallout: action.payload.featureCallout.feature_callout,
      isError: false,
      errorMessage: null,
      isLoading: false
    };
  },
  [CONTENTSTACK_ASYNC_ERROR]: (state, action) => {
    return {
      isLoading: false,
      isError: true,
      errorMessage: action.error,
    };
  }
};

export default function contentstack(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
